import type { CSSProperties, MouseEvent } from 'react';
import { Box } from '../../atoms/Box';
import { Text } from '../../atoms/Text';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';
import { splitNameInitial } from '../MobileListRow/splitNameInitial';

export interface ProductImageAvatarProps extends CoreProps {
  src?: string | null;
  name: string;
  size?: number;
  radius?: number | string;
  onClick?: (e: MouseEvent) => void;
}

export function ProductImageAvatar({
  src,
  name,
  size = 40,
  radius = 10,
  onClick,
  testId,
  view = 'all',
}: ProductImageAvatarProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;

  const initials = splitNameInitial(name);
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: typeof radius === 'number' ? radius : radius,
    objectFit: 'cover',
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    background: 'var(--mantine-color-gray-2)',
    overflow: 'hidden',
    cursor: onClick ? 'pointer' : undefined,
  };

  if (src) {
    return (
      <img
        src={src}
        alt=""
        data-testid={testId}
        onClick={onClick}
        style={style}
      />
    );
  }

  return (
    <Box data-testid={testId} onClick={onClick} style={style}>
      <Text size={size >= 48 ? 'md' : 'sm'} fw={600} c="brand">
        {initials}
      </Text>
    </Box>
  );
}
